import React from 'react';
import { Link } from 'react-router-dom';
import { Features } from '../components/Features';
import { TechStack } from '../components/TechStack';
import { RealExamples } from '../components/RealExamples';
import { Footer } from '../components/Footer';

export function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero 区域 */}
      <div className="relative overflow-hidden bg-white">
        <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              你的记忆，值得被更好地管理
            </h1>
            
            <p className="mt-6 text-lg leading-8 text-gray-600 max-w-2xl mx-auto">
              MemPalace 是一个简单的记忆管理系统，基于 Cloudflare 构建。
              我们尝试用更聪明的方式，帮你记住重要的事情。
            </p>
            
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/demo"
                className="btn btn-primary"
              >
                试试看
              </Link>
              <Link to="/docs" className="text-sm font-semibold leading-6 text-gray-900">
                了解更多 <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* 功能特性 */}
      <Features />
      
      {/* 技术标清 */}
      <TechStack />
      
      {/* 实陆案例 */}
      <RealExamples />
      
      {/* 脚擊 */}
      <Footer />
    </div>
  );
}
